import script from "./NewsPagePopupSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPagePopupSidebar.vue?vue&type=script&setup=true&lang=js"

import "./NewsPagePopupSidebar.vue?vue&type=style&index=0&id=617a8dd4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-617a8dd4"]])

export default __exports__